import { jsonParseSafe, jsonStringifySafe } from "../../utils/jsonParse";

export type AttributeValueType = "String" | "Boolean" | "Number" | "Array" | "Object";

export const parseAttributeToValue = (
  attributeValue: string | null,
  type: AttributeValueType = "String",
): string | boolean | number | undefined => {
  /*                                                                                                   */
  /*                                                                                                  */
  /*                                                      */
  if (type === "Boolean") return attributeValue !== null && attributeValue !== "false";
  if (type === "String") return attributeValue ?? undefined;
  /*                                                                               */
  /*                                                                */
  /*                                                                              */
  /*                                                                 */
  /*                                                                                  */
  return jsonParseSafe(attributeValue);
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const stringifyValueToAttribute = (
  host: HTMLElement,
  attribute: string,
  value: unknown,
  type: AttributeValueType = "String",
): unknown => {
  if (type === "Boolean") return host.toggleAttribute(attribute, Boolean(value));
  if (value == null) return host.removeAttribute(attribute);
  if (type === "String") return host.setAttribute(attribute, String(value));
  return host.setAttribute(attribute, jsonStringifySafe(value));
};
